import { useCallback, useRef, useState } from "react"

export function useHeaderCollapse() {
  const [headerExpanded, setHeaderExpanded] = useState(true)
  const expandLockRef = useRef(false)
  const lockTimerRef = useRef<ReturnType<typeof setTimeout>>()

  const handleNearTop = useCallback((nearTop: boolean) => {
    if (expandLockRef.current) return
    setHeaderExpanded(nearTop)
  }, [])

  const handleToggleExpand = useCallback(() => {
    setHeaderExpanded(true)
    expandLockRef.current = true
    clearTimeout(lockTimerRef.current)
    lockTimerRef.current = setTimeout(() => {
      expandLockRef.current = false
    }, 200)
  }, [])

  return { headerExpanded, handleNearTop, handleToggleExpand }
}
